var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "#ffffff",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 547 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -240 54 -54 113 -78 176 -72 25 2 35 8 37 23 2 18 -3 20 -57 21 -71 0 -125 31 -162 91 -36 57 -34 154 3 210 41 63 90 88 169 88 54 0 72 -5 106 -27 47 -31 78 -77 88 -130 5 -28 12 -38 26 -38 40 0 11 94 -48 160 -65 72 -158 97 -253 67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 390 l-49 -50 42 0 42 0 0 -70 c0 -63 2 -70 20 -70 18 0 20 7 20 70 l0 70 42 0 42 0 -49 50 c-27 28 -52 50 -55 50 -3 0 -28 -22 -55 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 250 c0 -23 -5 -30 -19 -30 -19 0 -21 -6 -37 -157 l-7 -63 123 0 123 0 -7 63 c-16 151 -18 157 -37 157 -14 0 -19 7 -19 30 l0 30 -60 0 -60 0 0 -30z m80 -20 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0 20 -4 20 -10z m44 -82 c3 -18 7 -50 10 -71 l5 -37 -79 0 -79 0 5 37 c15 113 8 103 74 103 59 0 59 0 64 -32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanos);
export default __webpack_public_path__ + "static/media/iconPlanos.7b274ae4e965c95351cb3c1f4c8c4c90.svg";
export { ForwardRef as ReactComponent };